import { SVGProps } from "react";

const Gallery = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={46}
    height={46}
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.2502 42.1666H28.7502C38.3335 42.1666 42.1668 38.3333 42.1668 28.75V17.25C42.1668 7.66665 38.3335 3.83331 28.7502 3.83331H17.2502C7.66683 3.83331 3.8335 7.66665 3.8335 17.25V28.75C3.8335 38.3333 7.66683 42.1666 17.2502 42.1666Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.2498 19.1667C19.3669 19.1667 21.0832 17.4504 21.0832 15.3333C21.0832 13.2162 19.3669 11.5 17.2498 11.5C15.1327 11.5 13.4165 13.2162 13.4165 15.3333C13.4165 17.4504 15.1327 19.1667 17.2498 19.1667Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.11768 36.3209L14.5668 29.9767C16.081 28.9609 18.266 29.0759 19.6268 30.245L20.2593 30.8009C21.7543 32.085 24.1693 32.085 25.6643 30.8009L33.6377 23.9584C35.1327 22.6742 37.5477 22.6742 39.0427 23.9584L42.1668 26.6417"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Gallery;
